import React from "react";
import { GeneralTagsManagerPage } from "@rankmi/ats-app";

// Refacfor de portales: Eliminar este archivo
const GeneralTags = ({ showAiTags }) => {
  return <GeneralTagsManagerPage showAiTags={showAiTags}/>
};

export default GeneralTags;